export default __webpack_public_path__ + "static/media/img2.cc1c33a1.png";